import Immutable from 'seamless-immutable';
import { createReducer, completeReducer, completeState, onReadValue } from 'redux-recompose';

import { actions } from './actions';

const stateDescription = {
  deliveryOptions: {},
  deliveryItems: [],
  deliveryTypeSelected: null,
  ordersUpdatingDelivery: []
};

const initialState = completeState(stateDescription, ['deliveryLoading']);

const reducerDescription = {
  primaryActions: [
    actions.CLEAR_DELIVERY_ESTIMATES,
    actions.SET_DELIVERY_ITEMS,
    actions.SET_DELIVERY_TYPE_SELECTED,
    actions.GET_DELIVERY_ESTIMATES,
    actions.CANCEL_DELIVERY
  ],
  override: {
    [actions.GET_DELIVERY_ESTIMATES_SUCCESS]: (state, action) => {
      if (action.payload) {
        if (action.payload.optionIndex >= 0) {
          const newDeliveryOptions = [...state.deliveryOptions[action.payload.orderId]];
          newDeliveryOptions[action.payload.optionIndex] = action.payload.data;

          return state.merge({
            ...state,
            deliveryOptions: {
              ...state.deliveryOptions,
              [action.payload.orderId]: newDeliveryOptions
            }
          });
        }

        return state.merge({
          ...state,
          deliveryOptions: {
            ...state.deliveryOptions,
            [action.payload.orderId]: state.deliveryOptions[action.payload.orderId]
              ? [...state.deliveryOptions[action.payload.orderId], action.payload.data]
              : [action.payload.data]
          }
        });
      }
      return state;
    },
    [actions.GET_DELIVERY_ESTIMATES_FAILURE]: (state, action) => {
      if (action.payload) {
        if (action.payload.optionIndex >= 0) {
          const newDeliveryOptions = [...state.deliveryOptions[action.payload.orderId]];
          newDeliveryOptions[action.payload.optionIndex] = action.payload.data;
          return state.merge({
            ...state,
            deliveryOptions: {
              ...state.deliveryOptions,
              [action.payload.orderId]: newDeliveryOptions
            }
          });
        }

        return state.merge({
          ...state,
          deliveryOptions: {
            ...state.deliveryOptions,
            [action.payload.orderId]: state.deliveryOptions[action.payload.orderId]
              ? [...state.deliveryOptions[action.payload.orderId], action.payload.data]
              : [action.payload.data]
          }
        });
      }
      return state;
    },
    [actions.CLEAR_DELIVERY_ESTIMATES]: (state, action) =>
      state.merge({
        ...state,
        deliveryOptions: [],
        deliveryItems: state.deliveryItems.filter((item) => item.id !== action.payload.id),
        deliveryTypeSelected: null
      }),
    [actions.SET_DELIVERY_ITEMS]: (state, action) =>
      state.merge({
        ...state,
        deliveryItems: [...state.deliveryItems, action.payload]
      }),
    [actions.SET_DELIVERY_LOADING]: onReadValue(),
    [actions.SET_DELIVERY_TYPE_SELECTED]: onReadValue(),
    [actions.SET_UPDATING_DELIVERY_ORDER]: (state, action) => {
      if (state.ordersUpdatingDelivery.find((order) => order.id === action.payload.id)) {
        return state.merge({
          ...state,
          ordersUpdatingDelivery: state.ordersUpdatingDelivery.filter(
            (order) => order.id !== action.payload.id
          )
        });
      }

      return state.merge({
        ...state,
        ordersUpdatingDelivery: [...state.ordersUpdatingDelivery, action.payload]
      });
    },
    [actions.SET_EXPIRED_STATUS]: (state, action) => {
      if (action.payload.optionIndex >= 0) {
        const newDeliveryOptions = [...state.deliveryOptions[action.payload.orderId]];
        newDeliveryOptions[action.payload.optionIndex] = {
          ...newDeliveryOptions[action.payload.optionIndex],
          expired: action.payload.isExpired
        };

        return state.merge({
          ...state,
          deliveryOptions: {
            ...state.deliveryOptions,
            [action.payload.orderId]: newDeliveryOptions
          }
        });
      }
    }
  }
};

export default createReducer(new Immutable(initialState), completeReducer(reducerDescription));
